import React from 'react';
import { Box, Button } from '@mui/material';

interface ActionButtonsSectionProps {
	isNewParkingLocation: boolean;
	loading: boolean;
	onArchive: () => void;
	onReset: () => void;
	onSave: () => void;
}

const ActionButtonsSection: React.FC<ActionButtonsSectionProps> = ({
	isNewParkingLocation,
	loading,
	onArchive,
	onReset,
	onSave,
}) => {
	return (
		<Box
			display="flex"
			justifyContent="space-between"
			alignItems="center"
			gap={2}
		>
			{!isNewParkingLocation && (
				<Button
					variant="outlined"
					color="error"
					onClick={onArchive}
					disabled={loading}
					aria-label="Archive parking location"
				>
					Archive
				</Button>
			)}

			<Box display="flex" gap={1}>
				<Button
					variant="outlined"
					color="secondary"
					onClick={onReset}
					disabled={loading}
					aria-label="Reset form"
				>
					Reset
				</Button>

				<Button
					variant="contained"
					data-tour="create-button"
					color="info"
					onClick={onSave}
					disabled={loading}
					aria-label={
						isNewParkingLocation
							? 'Create parking location'
							: 'Update parking location'
					}
				>
					{isNewParkingLocation ? 'Create' : 'Update'}
				</Button>
			</Box>
		</Box>
	);
};

export default ActionButtonsSection;
